import React from 'react';
import {
  Action,
  Actions,
  FileDownloadIcon,
  ActionBar,
  AddBoxIcon,
  IndeterminateCheckBoxIcon,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField, useScreenTitle } from '@gogame/screens';

export default function FinancialResultToolbar({
  onCreate,
  onOpenSubscriptionsForm,
  onExport,
  allExpanded,
  onToggleAll,
}) {
  const [screenTitle] = useScreenTitle();

  return (
    <>
      <ActionBar
        title={screenTitle}
        search={<SearchField tooltip={'Search by id'} />}
        secondaryActions={
          <Actions>
            <Action
              icon={
                allExpanded ? <IndeterminateCheckBoxIcon /> : <AddBoxIcon />
              }
              onClick={onToggleAll}
              tooltip={allExpanded ? 'Collapse All' : 'Expand All'}
            />
            <Action
              icon={<FileDownloadIcon />}
              label={'Export'}
              tooltip={'Export'}
            >
              <Action onClick={onExport} label={'Export'} />
              <Action label={'Subscribe'} onClick={onOpenSubscriptionsForm} />
            </Action>
            <Action component={FullScreenToggler} />
          </Actions>
        }
        primaryActions={
          <Actions>
            <Action
              border={true}
              button={true}
              add={true}
              iconContent={true}
              tooltip={'Add Financial Result'}
              variant={'outlined'}
              onClick={onCreate}
            />
          </Actions>
        }
      />
    </>
  );
}
